import { BigNumber, utils } from 'ethers';
import { Token } from '../datas/tokens';
import { ConvertAmountRangeRes } from '../apis/bridgeAPI/cryptocurrency/types';

interface CalculateTaxParams {
  chainTransferTax?: ConvertAmountRangeRes | null;
  token?: Token;
  transferAmount?: string | null;
}
const MIN_RATE_DECIMALS = 1000;

// 체인간 송금 수수료 금액 계산 유틸
export const calcTaxAmount = ({
  chainTransferTax,
  transferAmount,
  token,
}: CalculateTaxParams): string => {
  if (!transferAmount || !chainTransferTax || !token) {
    return ``;
  }

  if (transferAmount && chainTransferTax) {
    const tax = utils.formatUnits(
      BigNumber.from(utils.parseUnits(transferAmount, token.decimals))
        .mul(BigNumber.from(Number(chainTransferTax.tax) * MIN_RATE_DECIMALS))
        .div(BigNumber.from(MIN_RATE_DECIMALS * 100)),
      token.decimals,
    );

    if (Number(tax) < Number(chainTransferTax.minTaxAmount)) {
      return `${chainTransferTax.minTaxAmount}`;
    }

    return tax;
  }
  return ``;
};

export const roundToDecimals = (amount: any, decimals = 5) =>
  (
    Math.round((Number(amount) + Number.EPSILON) * 10 ** decimals) /
    10 ** decimals
  ).toString();

export const floorToDecimals = (amount: any, decimals = 5) =>
  (
    Math.floor((Number(amount) + Number.EPSILON) * 10 ** decimals) /
    10 ** decimals
  ).toString();
